// extracted by mini-css-extract-plugin
module.exports = {"text":"ErrorDialog_text__yFAhd","titleText":"ErrorDialog_titleText__3w1oq","content":"ErrorDialog_content__1ha9h"};